import {RELATIVES_API_URL} from "../../../shared/constants/api";

export const LOGIN_URL = `${RELATIVES_API_URL}/v2/auth`;
export const REGISTER_URL = `${RELATIVES_API_URL}/v2/add_customer`;
export const PROFILE_URL = `${RELATIVES_API_URL}/v2/customer/info`;
export const PASSWORD_RESET_URL = `${RELATIVES_API_URL}/v2/password/reset`;
export const NEW_PASSWORD_URL = `${RELATIVES_API_URL}/v2/password/new`;
export const DELETE_ACCOUNT_URL = `${RELATIVES_API_URL}/v2/customer/delete`;
